import React, { useState, useEffect } from 'react'
import { Box, Container, makeStyles, CircularProgress } from '@material-ui/core'
import Page from '../../../components/Page'
import firebase from 'firebase/app'
import Results from './Results'
import Toolbar from './Toolbar'

import 'firebase/firestore'

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    loader: {
        color: '#fff',
        position: 'fixed',
        backgroundColor: theme.palette.primary.main,
        top: 74,
        paddingTop: 5,
        paddingBottom: 5,
        paddingRight: 10,
        paddingLeft: 10,
        borderRadius: 4,
        left: '50%',
        marginLeft: -42,
        zIndex: 9
    }
}))

const SettingsView = () => {
    const classes = useStyles()
    const [users, setUsers] = useState()
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(0)
    const [nextRef, setNextRef] = useState()
    const [noMoreData, setNoMoreData] = useState(false)
    const [loading, setLoading] = useState(false)
    const dataRef = firebase
        .firestore()
        .collection('admins')
        .orderBy('createDate', 'desc')

    async function appendNewUsers() {
        setLoading(true)
        return dataRef
            .startAfter(nextRef)
            .limit(50)
            .get()
            .then((query) => {
                if (query.empty) {
                    setNoMoreData(true)
                    setLoading(false)
                } else {
                    if (query.docs.length < 50) {
                        setNoMoreData(true)
                    }
                    const data = []
                    query.docs.forEach((user) => {
                        const _data = user.data()

                        data.push({ ..._data, id: user.id })
                    })

                    const _nextRef = query.docs[query.docs.length - 1]
                    setNextRef(_nextRef)

                    setUsers((prevState) => {
                        const newArray = prevState.concat(data)
                        return newArray
                    })
                    setLoading(false)
                }
            })
            .catch(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        if (
            users?.length >= 50 &&
            !noMoreData &&
            users?.length - limit * page <= 25 &&
            !loading
        ) {
            appendNewUsers()
        }
    }, [page, limit, users, noMoreData, loading])

    useEffect(() => {
        dataRef
            .limit(50)
            .get()
            .then((docs) => {
                const _users = []
                if (!docs.empty) {
                    docs.forEach((user) => {
                        const _user = user.data()
                        _users.push({ ..._user, id: user.id })
                    })
                }

                const _nextRef = docs.docs[docs.docs.length - 1]
                setNextRef(_nextRef)

                setUsers(_users)
            })
    }, [])

    async function refreshUsers() {
        return dataRef
            .startAfter(nextRef)
            .get()
            .then((query) => {
                if (!query.empty) {
                    const _newPages = []
                    query.docs.forEach((newPage) => {
                        const _data = newPage.data()
                        _newPages.push({ ..._data, id: newPage.id })
                    })

                    setUsers((prevState) => {
                        const newArray = prevState.concat(_newPages)
                        return newArray
                    })
                }
            })
    }

    return (
        <Page className={classes.root} title="Users">
            <Container maxWidth={false}>
                {!users ? (
                    <CircularProgress />
                ) : (
                    <>
                        <Toolbar refreshAdmins={refreshUsers} />
                        <Box mt={3}>
                            {loading ? (
                                <p className={classes.loader}>Loading...</p>
                            ) : null}
                            <Results
                                {...{
                                    users,
                                    limit,
                                    setLimit,
                                    page,
                                    setPage,
                                    appendNewUsers,
                                    noMoreData
                                }}
                            />
                        </Box>
                    </>
                )}
            </Container>
        </Page>
    )
}

export default SettingsView
